import styled from 'styled-components';

import { ButtonGroup } from '@/ui/ButtonGroup';

export const Actions = styled(ButtonGroup)`
  grid-area: actions;
  justify-self: right;
`;
